import PropTypes from "prop-types";

/**
 * Card Data Shape
 * Shape for card data used in dashboard metrics and info displays
 *
 * @typedef {Object} CardData
 * @property {React.ReactNode} [icon] - Icon element to display
 * @property {string} title - Card title text (required)
 * @property {number|string} value - Numeric or string value to display (required)
 * @property {('currency'|'percentage'|'number'|'text')} [type] - Data type for formatting
 * @property {number} [decimals] - Number of decimal places to show
 * @property {number} [percentage] - Change percentage value for trend indicator
 * @property {('primary'|'secondary'|'success'|'danger'|'warning'|'info')} [appearance] - Visual color variant
 */
export const cardDataShape = PropTypes.shape({
  icon: PropTypes.node,
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  type: PropTypes.oneOf(["currency", "percentage", "number", "text"]),
  decimals: PropTypes.number,
  percentage: PropTypes.number,
  appearance: PropTypes.oneOf(["primary", "secondary", "success", "danger", "warning", "info"]),
});
